import React from 'react';
import styled from 'styled-components';
import { COLORS } from '@avalara/bat-apps-shared/lib/constants';
import { SIcon } from '@avalara/skylab-sdk/react';
import BuyButton from '../buy-button';
import { FormContainer } from '../styled/forms';
const nextSteps = [
    'Check your email for an invoice',
    'Payment is due upon receipt of invoice',
    "After you pay, we'll finish setting up your account",
    'Then you can get started on your VAT registrations',
];
const DarkBlueIcon = styled(SIcon) `
  color: ${COLORS.darkBlue};
`;
const Ioss = () => (React.createElement(FormContainer, null,
    React.createElement("h1", null, "Review your order"),
    React.createElement("p", null, "You\u2019re all set to purchase Avalara Import One-Stop Shop Solution. It includes intermediary services, monthly returns filing, and VAT reporting in all 27 EU member states."),
    React.createElement("p", { className: 'font-bold margin-top-sm' }, "Next steps:"),
    nextSteps.map((step, i) => React.createElement("p", { key: `nextstep${i}` },
        React.createElement(DarkBlueIcon, { name: 'check', className: 'margin-right-sm' }),
        step)),
    React.createElement("p", { className: 'margin-top-md' }, "Recurring charges will be processed with the payment method used to pay the initial invoice. You can update your payment method at any time."),
    React.createElement(BuyButton, null)));
export default Ioss;
